type CallbackType<T> = (...args: unknown[]) => T;

export class Debounce<T> {
  timeoutId: ReturnType<typeof setTimeout> | null = null;
  callback: CallbackType<T>;
  delayInMs: number;

  constructor(callback: CallbackType<T>, delayInMs = 300) {
    this.callback = callback;
    this.delayInMs = delayInMs;
  }

  execute(...args: unknown[]): void {
    this.cancelExecution();

    this.timeoutId = setTimeout(() => this.callback(...args), this.delayInMs);
  }

  cancelExecution = (): void => {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  };
}
